import React from "react";
import styled from "styled-components";

const Preview = styled.div`
min-height: 29.63px;
display: inline-flex;
align-items: center;
`
export default Preview